import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

import { breakpoint } from './Card';

export default styled.div`
  grid-area: details;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1rem;
  padding: 1rem 1rem 1rem 0;

  ${upTo(breakpoint)`
    grid-template-columns: 100%;
    padding: 0 1rem 1rem 1rem;
  `}
`;
